
import React from 'react';
import { Button } from '@/components/ui/button';
import { ExternalLink } from 'lucide-react';
import { Transaction } from '@/types/transaction';

interface TransactionFooterProps {
  transaction: Transaction | null;
  onClose: () => void;
}

const TransactionFooter: React.FC<TransactionFooterProps> = ({ transaction, onClose }) => {
  const handleViewInStripe = () => {
    if (!transaction) return;
    
    // Replace with the right URL for your Stripe dashboard
    const stripeUrl = transaction?.accountId 
      ? `https://dashboard.stripe.com/${transaction.accountId}/payments/${transaction.payment_intent_id || transaction.id}`
      : `https://dashboard.stripe.com/payments/${transaction.payment_intent_id || transaction.id}`;
    window.open(stripeUrl, '_blank');
  };

  return (
    <div className="flex justify-end w-full">
      {/* <Button variant="outline" onClick={onClose}>
        Close
      </Button> */}
      <Button onClick={handleViewInStripe}
      className="fixed bottom-0 left-0 right-0 mx-4 mb-6 rounded-md" 
      >
        <ExternalLink className="mr-2 h-4 w-4" />
        View in Stripe
      </Button>
    </div>
  );
};

export default TransactionFooter;
